<div class="pdf-page app-aul-011-24" id="aul01124">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large mb-0" style="text-align: center">
    <b>AUL INSPECTION NOTICE</b>
  </p>
  
  <div class="font-small">
    <p>
      <b>
        This policy has been underwritten, accepted, priced and issued on the
        terms and conditions described in this policy, based on the information
        provided by You and on your behalf by your agent during the application
        and quote process.
      </b>
    </p>
    <p>
      <b>
        All bound policies are subject to an inspection process to validate and
        electronically confirm this information
      </b>
    </p>
    <p>
      The Inspection will be conducted on our behalf by our inspection service
      provider:
    </p>
    <p><b>Preferred Reports Inc.</b></p>
    <p>
      More information can be found on their website
      <span
        ><a href="https://www.preferredreports.com" target="_blank" class="link"
          >https://www.preferredreports.com</a
        ></span
      >
    </p>
    <p>
      Our Inspection service provider will contact you within 7 days of the
      policy inception.
    </p>
    <p>
      This Policy is accepted and issued subject to your completion of the
      inspection process, which will include your electronic confirmation of the
      application information, of your TRIA election and completion of our
      requirements under the US Treasury Department’s Office of Foreign Assets
      Control (OFAC).
    </p>
    <p>
      This inspection process should be completed in a reasonable timeframe,
      which is 30 days from the initial contact date by our inspection service
      provider.
    </p>
    <p>
      Should the inspection process result in information that differs from the
      information provided by You or your agent, or does not meet AUL
      underwriting guidelines, your Policy may be cancelled or subject to
      premium adjustment.
    </p>
    <p>
      We may cancel your policy for failure to complete the inspection process
      within this timeframe.
    </p>
  </div>
</div>
